import styled from "styled-components"
import { Row, Col, Accordion } from "react-bootstrap";
import { BPSAccordionStyled } from "../styled/BPSAccordion";

import DetailedReporting from '../../assets/images/Rebates - Detailed Analytics.png';
import EfficientValidation from '../../assets/images/Rebates - Pending Claims.png';
import Security from '../../assets/images/Rebates - Top Security.png';
import Communication from '../../assets/images/Rebates - Engaging Communication.png';

import { BPSCheckmarkList, Checkmark } from "../styled/Lists";
import { BPSArrowLink, Arrow } from "../styled/Buttons";


const FAQAccordion = () => {
    return (
        <BPSAccordionStyled>
            <Accordion alwaysOpen >
                <Accordion.Item eventKey="0">
                    <Accordion.Header>How do I start an incentive program?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            There are various considerations to take into account when launching an incentive program. Usually these can be broken down into the following steps:
                        </p>
                        <ol>
                            <li>
                                Identify a specific measurable goal you want your incentive program to promote.
                            </li>
                            <li>
                                Analyze your target audience. This is the group of people whose behavior you are trying to influence.
                            </li>
                            <li>
                                Decide which reward type - online rewards, gift cards, debit cards, or incentive travel – will be most effective in motivating your target audience.
                            </li>
                            <li>
                                Determine your program budget. Usually an incentive program is a mix of fixed expense and variable expense and is shared between sales and marketing.
                            </li>
                            <li>
                                Enlist the help of an outside incentive company to design a website for your program, manage your promotions, market your program, and help with onboarding.
                            </li>
                            <li>
                                Explore what type of messaging you would like your incentive program to include. The appeal of rewards will make program participants more receptive to your marketing and provides a great opportunity to educate participants on your products and your brands.
                            </li>
                            <li>
                                Structure various promotions to achieve different phases of your overall objective.
                            </li>
                            <li>
                                Monitor reports to make sure your incentive program is on track to achieve your goals.
                            </li>
                            <li>
                                Enjoy the benefits!
                            </li>
                        </ol>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>How do you create incentives?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            While it is possible for a company to manage their incentive program internally, this isn't practical for most businesses. Usually businesses have an idea of the outcome they would like their incentive program to accomplish, and maybe even the reward type they'd like to use, but they leave the planning, design, program management, and reward fulfillment to incentive companies that specialize in that area.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header>What are the three types of incentives?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            The most common types of incentives include:
                        </p>
                        <ul>
                            <li>
                                <strong>B2B Customer Loyalty Incentives</strong> - B2B customer loyalty incentives are used to reward customers and increase the profitability of customer accounts by incentivizing them to stay faithful to your brand.
                            </li>
                            <li>
                                <strong>Channel Partner Incentives</strong> - Channel partner incentives are used to motivate dealers, contractors, and other external sales reps to prioritize your product when advising end-users. Additionally, channel partner incentives can be used as part of a data collection strategy in order to collect cleaner, more complete sales and marketing data.
                            </li>
                            <li>
                                <strong>Employee Recognition Incentives</strong> - Employee recognition incentives are used to create a culture of top performance, to inspire employees to exceed their goals, and to reduce employee turnover.
                            </li>
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                    <Accordion.Header>What is incentive marketing?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            Business Dictionary defines incentive marketing as the “use of motivational devices such as competitions, games, premiums, and special prices, to promote the sale of a merchandise or service.” In B2B marketing, where products and services are generally more complex and solution-focused than B2C, incentive programs can be an important tool to offer long-term education to customers or to gather more information to personalize future marketing.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                    <Accordion.Header>Why do incentive programs fail?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            An incentive program, if not properly managed, can fail for any number of reasons. Some of these include any combination of the following:
                        </p>

                        <ul>
                            <li>
                                Lack of a specific goal and a clear plan of action.
                            </li>
                            <li>
                                Rewards that aren't compelling or don't seem worth the effort.
                            </li>
                            <li>
                                Ineffective program marketing or a lack of consistent communication with program participants.
                            </li>
                            <li>
                                Inefficient logistics that make reward fulfillment too time-consuming for the business offering the program, or too slow to establish the relationship between relationship and reward for the participants.
                            </li>
                            <li>
                                No access to automated analytics and easy-to-use admin dashboards means that valuable behavioral data gets lost and managing the program becomes too difficult.
                            </li>
                            <li>
                                Due to the various moving parts that are necessary for a successful incentive program, many businesses outsource their incentive program to a trusted incentive management company.
                            </li>
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="5">
                    <Accordion.Header>How does a long-term incentive plan work?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            A long term incentive plan is one that is designed to result in long-lasting changes in behaviors and to help a company achieve long term objectives. While short term incentive programs usually use lower investment rewards that are less personalized (like debit card rewards), long term incentive programs use scalable, highly personalized rewards that keeps participants engaged across different segments of performance. Additionally, long term incentive plans require a more complete marketing and communication plan to keep the program top of mind with participants through the lifetime of the program.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

            </Accordion>
        </BPSAccordionStyled >
    );
}


export { FAQAccordion }
